/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { NodeCompat } from '../../compat/NodeCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { OasSchema } from '../../openapi/models/OasSchema';
import { Oas30Schema } from '../../openapi/v3/models/Oas30Schema';
import { AbstractSchemaInhCommand } from './AbstractSchemaInhCommand';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete all child schemas from a schema.
 * @author eric.wittmann@gmail.com
 * @extends AbstractSchemaInhCommand
 * @class
 */
export class DeleteAllChildSchemasCommand extends AbstractSchemaInhCommand {
    public _schemaPath : NodePath;

    public _childSchemaType : string;

    public _oldSchemas : Array<any>;

    public constructor(parent? : any, type? : any) {
        if(((parent != null && parent instanceof <any>OasSchema) || parent === null) && ((typeof type === 'string') || type === null)) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._childSchemaType===undefined) this._childSchemaType = null;
            if(this._oldSchemas===undefined) this._oldSchemas = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._childSchemaType===undefined) this._childSchemaType = null;
            if(this._oldSchemas===undefined) this._oldSchemas = null;
            (() => {
                this._schemaPath = Library.createNodePath(<Node>parent);
                this._childSchemaType = type;
            })();
        } else if(parent === undefined && type === undefined) {
            let __args = arguments;
            super();
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._childSchemaType===undefined) this._childSchemaType = null;
            if(this._oldSchemas===undefined) this._oldSchemas = null;
            if(this._schemaPath===undefined) this._schemaPath = null;
            if(this._childSchemaType===undefined) this._childSchemaType = null;
            if(this._oldSchemas===undefined) this._oldSchemas = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllChildSchemasCommand] Executing.");
        this._oldSchemas = <any>([]);
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        let schemas : Array<OasSchema> = <any>([]);
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ALL_OF, this._childSchemaType)) {
            schemas = schema.allOf;
            schema.allOf = <any>([]);
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ANY_OF, this._childSchemaType)) {
            let schema30 : Oas30Schema = <Oas30Schema>schema;
            schemas = schema30.anyOf;
            schema30.anyOf = <any>([]);
        }
        if(NodeCompat.equals(AbstractSchemaInhCommand.TYPE_ONE_OF, this._childSchemaType)) {
            let schema30 : Oas30Schema = <Oas30Schema>schema;
            schemas = schema30.oneOf;
            schema30.oneOf = <any>([]);
        }
        if(this.isNullOrUndefined(schemas)) {
            return;
        }
        this._oldSchemas = <any>([]);
        schemas.forEach((oldSchema) => {
            /* add */(this._oldSchemas.push(Library.writeNode(oldSchema))>0);
        });
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(io.apicurio.datamodels.core.models.Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllChildSchemasCommand] Reverting.");
        if(this.isNullOrUndefined(this._oldSchemas) || /* size */(<number>this._oldSchemas.length) === 0) {
            return;
        }
        let schema : OasSchema = <OasSchema>this._schemaPath.resolve(document);
        if(this.isNullOrUndefined(schema)) {
            return;
        }
        this.copySchemaJsTo(this._oldSchemas, schema, this._childSchemaType);
    }
}
DeleteAllChildSchemasCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllChildSchemasCommand";
DeleteAllChildSchemasCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




